import { Actions } from './actions';
import {
  CLEAR_COUNTERPARTY_DETAILS,
  CLOSE_ERROR_MODAL_COUNTERPARTY,
  CLOSE_ERROR_POPUP_COUNTERPARTY,
  DELETE_COUNTERPARTY_ERROR,
  DELETE_COUNTERPARTY_REQUEST,
  DELETE_COUNTERPARTY_SUCCESS,
  GET_COUNTERPARTIES_LIST_ERROR,
  GET_COUNTERPARTIES_LIST_REQUEST,
  GET_COUNTERPARTIES_LIST_SUCCESS,
  GET_COUNTERPARTY_DETAILS_ERROR,
  GET_COUNTERPARTY_DETAILS_REQUEST,
  GET_COUNTERPARTY_DETAILS_SUCCESS,
  POST_ADD_COUNTERPARTY_ERROR,
  POST_ADD_COUNTERPARTY_REQUEST,
  POST_ADD_COUNTERPARTY_SUCCESS,
  PUT_UPDATE_COUNTERPARTY_ERROR,
  PUT_UPDATE_COUNTERPARTY_REQUEST,
  PUT_UPDATE_COUNTERPARTY_SUCCESS,
} from './constants';
import { ICounterparty } from './interfaces';

const initialState = {
  loading: false as boolean,
  modalLoading: false as boolean,
  counterparties: [] as ICounterparty[],
  counterpartyDetails: null as ICounterparty | null,

  newCounterparty: null as ICounterparty | null,
  updateCounterpartyResponse: null as ICounterparty | null,
  deleteCounterpartyResponse: false as boolean,

  getCounterpartiesErrorResponses: {} as any,
  getCounterpartyDetailsErrorResponses: {} as any,
  addCounterpartyErrorResponses: {} as any,
  updateCounterpartyErrorResponses: {} as any,
  deleteCounterpartyErrorResponses: {} as any,
};

export type CounterpartyState = typeof initialState;

export const CounterpartyReducer = (state: CounterpartyState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_COUNTERPARTIES_LIST_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
    case GET_COUNTERPARTIES_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        counterparties: action.payload,
      };
    }
    case GET_COUNTERPARTIES_LIST_ERROR: {
      return {
        ...state,
        loading: false,
        getCounterpartiesErrorResponses: action.payload,
      };
    }

    case CLOSE_ERROR_MODAL_COUNTERPARTY: {
      return {
        ...state,
        getCounterpartiesErrorResponses: {},
      };
    }

    case GET_COUNTERPARTY_DETAILS_REQUEST: {
      return {
        ...state,
        modalLoading: true,
        counterpartyDetails: null,
        getCounterpartyDetailsErrorResponses: {},
      };
    }
    case GET_COUNTERPARTY_DETAILS_SUCCESS: {
      return {
        ...state,
        modalLoading: false,
        counterpartyDetails: action.payload,
      };
    }
    case GET_COUNTERPARTY_DETAILS_ERROR: {
      return {
        ...state,
        modalLoading: false,
        getCounterpartyDetailsErrorResponses: action.payload,
      };
    }
    case CLEAR_COUNTERPARTY_DETAILS: {
      return {
        ...state,
        counterpartyDetails: null,
        getCounterpartyDetailsErrorResponses: {},
      };
    }

    case POST_ADD_COUNTERPARTY_REQUEST: {
      return {
        ...state,
        modalLoading: true,
        newCounterparty: null,
      };
    }
    case POST_ADD_COUNTERPARTY_SUCCESS: {
      return {
        ...state,
        modalLoading: false,
        newCounterparty: action.payload,
      };
    }
    case POST_ADD_COUNTERPARTY_ERROR: {
      return {
        ...state,
        modalLoading: false,
        addCounterpartyErrorResponses: action.payload,
      };
    }

    case PUT_UPDATE_COUNTERPARTY_REQUEST: {
      return {
        ...state,
        modalLoading: true,
      };
    }
    case PUT_UPDATE_COUNTERPARTY_SUCCESS: {
      return {
        ...state,
        modalLoading: false,
        updateCounterpartyResponse: action.payload,
      };
    }
    case PUT_UPDATE_COUNTERPARTY_ERROR: {
      return {
        ...state,
        modalLoading: false,
        updateCounterpartyErrorResponses: action.payload,
      };
    }

    case DELETE_COUNTERPARTY_REQUEST: {
      return {
        ...state,
        modalLoading: true,
      };
    }
    case DELETE_COUNTERPARTY_SUCCESS: {
      return {
        ...state,
        modalLoading: false,
        deleteCounterpartyResponse: action.payload,
      };
    }
    case DELETE_COUNTERPARTY_ERROR: {
      return {
        ...state,
        modalLoading: false,
        deleteCounterpartyErrorResponses: action.payload,
      };
    }

    case CLOSE_ERROR_POPUP_COUNTERPARTY: {
      return {
        ...state,
        getCounterpartiesErrorResponses: {},
        getCounterpartyDetailsErrorResponses: {},
        addCounterpartyErrorResponses: {},
        updateCounterpartyErrorResponses: {},
        deleteCounterpartyErrorResponses: {},
      };
    }

    default: {
      return state;
    }
  }
};
